import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


//import css for frontend
import "./frontend/assets/css/bootstrap.min.css"
import "./frontend/assets/css/fontawesome.min.css"
import "./frontend/assets/css/magnific-popup.min.css"
import "./frontend/assets/css/slick.min.css"
import "./frontend/assets/css/style.css"
import "./frontend/assets/css/section-style.css"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
